import { Resource } from "src/app/core/jsonapi/resource";
import { prop } from "@rxweb/reactive-form-validators";

export class DialPlanActionBranch extends Resource {
    public override type = 'dialPlanActionBranches';

    @prop()
    public dialPlanActionId!: string;

    @prop()
    public digit!: string;

    @prop()
    public positionX?: number;

    @prop()
    public positionY?: number;
}
